function withTrailingSlash(url: string): string {
  const s = url.trim();
  return s.endsWith("/") ? s : `${s}/`;
}

const SHOP_PATH = "/shop";
const CHECKLISTEN_PATH = "/checklisten";
const FLOW_MANAGER_PATH = "/flow-manager";

export function getProductSwitcherUrls(): {
  shopUrl: string;
  checklistenUrl: string;
  flowManagerUrl: string;
} {
  return {
    shopUrl: withTrailingSlash(SHOP_PATH),
    checklistenUrl: withTrailingSlash(CHECKLISTEN_PATH),
    flowManagerUrl: withTrailingSlash(FLOW_MANAGER_PATH),
  };
}
